import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44688358"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row g-5 g-xxl-8" }
const _hoisted_2 = { class: "col-xl-12" }
const _hoisted_3 = { class: "card p-5 mb-5 mb-xxl-8" }
const _hoisted_4 = { class: "p-fluid p-grid p-formgrid" }
const _hoisted_5 = { class: "p-field p-col-12 p-md-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "basic" }, "Fecha inicio emisión", -1))
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "p-field p-col-12 p-md-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "dateformat" }, "Fecha final emisión", -1))
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "p-field p-col-12 p-md-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "icon" }, "Estado", -1))
const _hoisted_15 = { class: "p-field p-col-12 p-md-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "factura" }, "Nº Factura", -1))
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "p-field p-col-12 p-md-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "icon" }, "Empresa", -1))
const _hoisted_21 = { class: "p-field p-col-12 p-md-2 p-md-1 mt-7 pl-5 pr-5" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "icon" }, null, -1))
const _hoisted_23 = { class: "card p-5 mb-5 mb-xxl-8" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 p-text-bold" }, "Agent Picker", -1))
const _hoisted_25 = { class: "p-multiselect-representative-option" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png",
  width: "30",
  style: {"vertical-align":"middle"}
}, null, -1))
const _hoisted_27 = { class: "image-text" }
const _hoisted_28 = { class: "p-d-flex p-ai-center p-jc-between p-px-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "demo/images/nature/nature1.jpg",
  alt: "Nature Image"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Form, {
            id: "kt_account_profile_details_form",
            class: "form",
            novalidate: "novalidate",
            onSubmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.buscarFacturas(false))),
            "validation-schema": _ctx.buscadorValidator
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_Calendar, {
                    id: "basic",
                    modelValue: _ctx.buscador.fechaInicio,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.buscador.fechaInicio) = $event)),
                    autocomplete: "off",
                    showIcon: true
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_ErrorMessage, { name: "fechaInicio" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_Calendar, {
                    id: "dateformat",
                    modelValue: _ctx.buscador.fechaTermino,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.buscador.fechaTermino) = $event)),
                    dateFormat: "mm-dd-yy",
                    showIcon: true
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_ErrorMessage, { name: "fechaTermino" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_Dropdown, {
                    showClear: true,
                    modelValue: _ctx.buscador.estado,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.buscador.estado) = $event)),
                    options: _ctx.estados,
                    optionValue: "estado",
                    optionLabel: "estado",
                    placeholder: "Todos"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_Field, {
                    type: "number",
                    class: "p-dropdown-label p-inputtext p-placeholder",
                    name: "factura",
                    id: "factura",
                    modelValue: _ctx.buscador.factura,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.buscador.factura) = $event)),
                    placeholder: "Nº Factura"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_ErrorMessage, { name: "factura" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_Dropdown, {
                    showClear: true,
                    modelValue: _ctx.buscador.empresaId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.buscador.empresaId) = $event)),
                    options: _ctx.empresas,
                    optionValue: "id",
                    optionLabel: "nombre",
                    placeholder: "Todos"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_Button, {
                    type: "submit",
                    label: " Buscar",
                    icon: "pi pi-search",
                    iconPos: "left",
                    style: {"width":"auto !important"},
                    class: "btn btn-melon"
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_DataTable, {
            value: _ctx.store.getters.allFacturas,
            paginator: true,
            rows: 10,
            showGridlines: "",
            dataKey: "id",
            rowHover: true,
            selection: _ctx.selectedCustomers,
            "onUpdate:selection": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCustomers) = $event)),
            filters: _ctx.filters1,
            "onUpdate:filters": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters1) = $event)),
            loading: _ctx.loading,
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
            rowsPerPageOptions: [10, 25, 50],
            currentPageReportTemplate: "Mostrando {first} a {last} de {totalRecords} registros",
            globalFilterFields: [
            'numeroFactura',
            'nombreEmpresa',
            'detalleEstado',
          ],
            responsiveLayout: "scroll"
          }, {
            empty: _withCtx(() => [
              _createTextVNode(" No existen documentos. ")
            ]),
            loading: _withCtx(() => [
              _createTextVNode(" Cargando sus documentos. Por favor espere. ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "numeroFactura",
                header: "Nº Factura",
                sortable: "",
                style: {"min-width":"9rem"}
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(data.numeroFactura), 1)
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    class: "p-column-filter",
                    placeholder: "Search by name"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "nombreEmpresa",
                header: "Empresa",
                sortable: "",
                filterMatchMode: "contains",
                style: {"min-width":"14rem"}
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(data.nombreEmpresa), 1)
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    class: "p-column-filter",
                    placeholder: "Search by country"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "detalleEstado",
                header: "Estado",
                sortable: "",
                filterField: "detalleEstado",
                sortField: "detalleEstado",
                showFilterMatchModes: false,
                filterMenuStyle: { width: '14rem' },
                style: {"min-width":"14rem"}
              }, {
                body: _withCtx(({ data }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["image-text", 'customer-badge status-' + data.estado])
                  }, _toDisplayString(data.detalleEstado), 3)
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _hoisted_24,
                  _createVNode(_component_MultiSelect, {
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    options: _ctx.representatives,
                    optionLabel: "name",
                    placeholder: "Any",
                    class: "p-column-filter"
                  }, {
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("span", _hoisted_27, _toDisplayString(slotProps.option.name), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "monto",
                header: "Monto",
                sortable: "",
                dataType: "numeric",
                style: {"min-width":"8rem"}
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(_ctx.formatCurrency(data.monto)), 1)
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_InputNumber, {
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    mode: "currency",
                    currency: "USD",
                    locale: "en-US"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "fechaEmision",
                header: "F. Emisión",
                sortable: "",
                dataType: "date",
                style: {"min-width":"8rem"}
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(data.fechaEmision)), 1)
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_Calendar, {
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    dateFormat: "mm/dd/yy",
                    placeholder: "mm/dd/yyyy"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "fechaRecepcion",
                header: "F. Recepción",
                sortable: "",
                dataType: "date",
                style: {"min-width":"8rem"}
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(data.fechaRecepcion)), 1)
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_Calendar, {
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    dateFormat: "mm/dd/yy",
                    placeholder: "mm/dd/yyyy"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "fechaPago",
                header: "F. Pago",
                sortable: "",
                dataType: "date",
                style: {"min-width":"8rem"}
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(data.fechaPago)), 1)
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_Calendar, {
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    dateFormat: "mm/dd/yy",
                    placeholder: "mm/dd/yyyy"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "numeroOrdenCompra",
                header: "Nº OC",
                sortable: "",
                showFilterMatchModes: false,
                style: {"min-width":"10rem"}
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(data.numeroOrdenCompra) + " ", 1),
                  _createVNode(_component_ProgressBar, {
                    value: data.numeroOrdenCompra,
                    showValue: false
                  }, null, 8, ["value"])
                ]),
                filter: _withCtx(({ filterModel }) => [
                  _createVNode(_component_Slider, {
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    range: "",
                    class: "p-m-3"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("span", null, _toDisplayString(filterModel.value ? filterModel.value[0] : 0), 1),
                    _createElementVNode("span", null, _toDisplayString(filterModel.value ? filterModel.value[1] : 100), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                headerStyle: "width: 4rem; text-align: center",
                bodyStyle: "text-align: center; overflow: visible"
              }, {
                body: _withCtx(({ data }) => [
                  _withDirectives(_createVNode(_component_Button, {
                    type: "button",
                    icon: "pi pi-comments",
                    onClick: ($event: any) => (_ctx.toggle(data))
                  }, null, 8, ["onClick"]), [
                    [_vShow, data.comentarios != '' && data.comentarios.length > 3]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "selection", "filters", "loading"])
        ])
      ])
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "op",
      showCloseIcon: true,
      dismissable: true
    }, {
      default: _withCtx(() => [
        _hoisted_29,
        _createTextVNode(" " + _toDisplayString(_ctx.comentario), 1)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Dialog, {
      header: "Observaciones",
      visible: _ctx.display,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.display) = $event))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.comentario), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}